import React, { useState } from "react";

import { CheckIcon, CloseIcon, SectionCard } from "shared/ui";
import { TariffDto } from "services/tariffs/restModels";

import { TARIFF_FEATURES } from "features/Tariff/constants";
import { useTariffContext } from "features/Tariff/context";

import {
    CurrentMark,
    Feature,
    FeatureList,
    Plan,
    PlanActions,
    PlanButton,
    PlanHeader,
    PlanPrice,
    PlanTitle,
    Plans,
    ToggleDetails,
    ToggleDetailsCell,
} from "./styles";

// Годовой период — самый выгодный, с него и открываем оплату (так было и в старом диалоге).
const DEFAULT_PAYMENT_PERIOD = "Year";

export const PlansTab = () => {
    const state = useTariffContext();
    const [expandedTariffId, setExpandedTariffId] = useState<string | null>(null);

    const renderPlan = (plan: TariffDto) => {
        const isExpanded = expandedTariffId === plan.id;
        const isCurrent = state.tariff?.type === plan.id;
        const cheapestPeriod = plan.periods.reduce((best, period) =>
            period.monthlyPrice.price < best.monthlyPrice.price ? period : best
        );

        return (
            <Plan key={plan.id}>
                <PlanHeader>
                    <div>
                        <PlanTitle>
                            {plan.title}
                            {plan.isLegacy && <CurrentMark>по старой цене</CurrentMark>}
                            {isCurrent && !plan.isLegacy && <CurrentMark>ваш тариф</CurrentMark>}
                        </PlanTitle>
                        <PlanPrice>
                            от {state.formatPrice(cheapestPeriod.monthlyPrice)} в месяц
                        </PlanPrice>
                    </div>

                    <PlanActions>
                        <ToggleDetailsCell>
                            <ToggleDetails
                                type="button"
                                onClick={() => setExpandedTariffId(isExpanded ? null : plan.id)}
                            >
                                {isExpanded ? "Скрыть" : "Подробнее"}
                            </ToggleDetails>
                        </ToggleDetailsCell>
                        <PlanButton onClick={() => state.openPayment(plan, DEFAULT_PAYMENT_PERIOD)}>
                            {isCurrent ? "Продлить" : "Подключить"}
                        </PlanButton>
                    </PlanActions>
                </PlanHeader>

                {isExpanded && (
                    <FeatureList>
                        {TARIFF_FEATURES.map((feature) => {
                            const included = feature.includedIn.indexOf(plan.id) !== -1;

                            return (
                                <Feature key={feature.title} $included={included}>
                                    {included ? (
                                        <CheckIcon fontSize="small" />
                                    ) : (
                                        <CloseIcon fontSize="small" />
                                    )}
                                    {feature.title}
                                </Feature>
                            );
                        })}
                    </FeatureList>
                )}
            </Plan>
        );
    };

    return (
        <SectionCard title="Тарифы">
            <Plans>{state.tariffs.map(renderPlan)}</Plans>
        </SectionCard>
    );
};
